module.exports = __webpack_public_path__ + "static/media/card_control.99719a1a.png";